// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__85M6J","bigColWidth":"Table_bigColWidth__1q4TP","biggerColWidth":"Table_biggerColWidth__1GHrR","row":"Table_row__rOzoW","col":"Table_col__1R8mT"};